var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.864,
    height: 17.864,
    viewBox: "0 0 17.864 17.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1776",
    "data-name": "Group 1776",
    transform: "translate(-50.1 -214.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-circle",
    "data-name": "Icon feather-message-circle",
    d: "M20.564,12.086a7.479,7.479,0,0,1-.8,3.391,7.586,7.586,0,0,1-6.783,4.195,7.479,7.479,0,0,1-3.391-.8L4.5,20.564l1.7-5.087a7.479,7.479,0,0,1-.8-3.391A7.586,7.586,0,0,1,9.587,5.3a7.479,7.479,0,0,1,3.391-.8h.446a7.568,7.568,0,0,1,7.14,7.14Z",
    transform: "translate(46.5 210.968)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone",
    "data-name": "Icon awesome-phone",
    d: "M.27.357,1.783.008a.351.351,0,0,1,.4.2l.7,1.63a.348.348,0,0,1-.1.407L1.9,2.969A5.393,5.393,0,0,0,4.478,5.547L5.2,4.666a.349.349,0,0,1,.407-.1l1.63.7a.353.353,0,0,1,.2.4L7.091,7.178a.349.349,0,0,1-.34.271A6.751,6.751,0,0,1,0,.7.349.349,0,0,1,.27.357Z",
    transform: "translate(55.687 219.396)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsappIcon_.efe4d959d9de60cfab6f88bd76cb7b58.svg";
export { ForwardRef as ReactComponent };